var template = /*html*/"\n    <p class=\"m-loader__wrapper js-loading mu-mt-200\">\n        <span class=\"m-loader js-loader-container\"></span>\n        Recherche en cours...\n    </p>\n";
export default template;